import { Link } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import RecognitionFeed from 'components/recognitionFeed';

export default function Feed() {
  return (
    <>
      <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
        <div className="space-y-7 md:space-y-0 md:flex justify-between items-center mb-3 lg:mb-10">
          <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
            <div>
              <Link to="../">
                <button className="rounded-full bg-purple flex justify-center items-center p-1">
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>
            </div>

            <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full">Feed FLAP 360°</h1>
          </div>
        </div>

        <RecognitionFeed />
      </div>
    </>
  );
}
